module.exports = __webpack_public_path__ + "static/media/Articles 4.7d6d6bf0.svg";